
  import { feeNote } from '~/scripts/current';

  export default {
    computed: {
      current () { return this.$store.state.products.current; },
      fees () { return feeNote(this.current, this.$i18n); }
    }
  };
